import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { generateColor } from '@/templates/Cadastro/Funcionarios/organismos/forms/TabelaHorario/utils'
import opcoesDiasDSR from '@/templates/Cadastro/TabelaHorario/constants/opcoes-dia-dsr'
import { rotuloTipoTolerancia } from '@/templates/Cadastro/TabelaHorario/utils/tipo-tolerancia'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { TabelaHorarios, tabelaHorarios } from 'service/api'

function rotuloDiaDSR(valor: unknown) {
    return (
        opcoesDiasDSR().find(opcao => opcao.value === String(valor))?.label ??
        ''
    )
}

const columns: GridColDefPro[] = [
    {
        field: 'codigo',
        headerName: 'Código',
        width: 140,
        type: 'number',
        valueGetter: params => params.row.codigo || params.row.id,
    },
    {
        field: 'nome',
        headerName: 'Descrição',
        flex: 1,
        renderCell: ({ value }) => {
            const { dark } = generateColor(value)
            return (
                <>
                    <div
                        className="rounded-full size-4 border mr-2"
                        style={{
                            backgroundColor: dark,
                        }}
                    />
                    <span title={value}>{value}</span>
                </>
            )
        },
    },
    {
        field: 'tipoTolerancia',
        headerName: 'Tipo de tolerância',
        width: 180,
        valueGetter: params => rotuloTipoTolerancia(params.row),
    },
    {
        field: 'diaDescontoDSR',
        headerName: 'Dia do DSR',
        width: 160,
        valueGetter: params => rotuloDiaDSR(params.row.diaDescontoDSR),
    },
    {
        field: 'totSem',
        headerName: 'Carga semanal',
        width: 140,
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: ({ id }) =>
            hasPermission(['update', 'TabelaDeHorários'], () => (
                <IconButton title="Editar" href={`${id}/editar`}>
                    <PencilIcon />
                </IconButton>
            )),
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) =>
            hasPermission(['delete', 'TabelaDeHorários'], () => (
                <IconButton title="Excluir" href={`${id}/excluir`}>
                    <Trash2Icon className="text-error" />
                </IconButton>
            )),
    },
]

export default function TabelaHorario() {
    const { data = [], isLoading } = tabelaHorarios.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Cadastros', 'Tabela de horários']}
                />
                <ContentGuide.DataGrid
                    onAdd
                    rows={data}
                    columns={columns}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-tabela-horario',
                        },
                        showQuickFilter: true,
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useTabelaHorariosOutletContext() {
    return useOutletContext<{ data: TabelaHorarios[] }>()
}
